import { render, staticRenderFns } from "./reOrderVisit.vue?vue&type=template&id=047bf516&scoped=true"
import script from "./reOrderVisit.vue?vue&type=script&lang=js"
export * from "./reOrderVisit.vue?vue&type=script&lang=js"
import style0 from "./reOrderVisit.vue?vue&type=style&index=0&id=047bf516&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "047bf516",
  null
  
)

export default component.exports